import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AccountModel} from "../../angular/models/account.model";
import {AccountsAlerts} from "../../services/accounts-alerts.service";
import {$accountFactory} from "../../$account.factory";
import {SplitService} from "../../../commons/services/split-service.service";

export class ShipperAccountDispatchingCtrl implements IController {

  account: AccountModel;

  private accountCopy: any;
  private accountRef: any;
  private dispatchModes: any;
  private siteId: any;
  private canUpdate: any;
  private loading: any;

  constructor(private $account: $accountFactory, private IAMPermissions, private accountsAlerts: AccountsAlerts, private $log, private splitService: SplitService) {
  }

  $onInit() {
    this.dispatchModes = {};
    this.siteId = this.splitService.getSiteId();
    this.canUpdate = this.IAMPermissions.hasPermission('accounts.demand.update');


    // Init Account Bringoz Object By Account Id.
    this.accountRef = this.$account(this.account.id);

    this.accountCopy = angular.copy(this.account);

    // Init Dispatch Modes.
    this.dispatchModes = {
      Default: 'Site Default',
      LeaveUnassigned: 'Leave Unassigned',
      AutoAssign: 'Auto Assign',
      AutoForceAssign: 'Auto Force Assign',
      PutToAuction: 'Put To Auction',
      MoveToMarket: 'Move To Market'
    };
  };

  update() {
    if (!_.isEqual(this.account, this.accountCopy)) {
      this.loading = true;
      this.accountRef.$update(this.account)
        .then((updatedAccount) => {
          this.account = updatedAccount;
          this.accountCopy = angular.copy(updatedAccount);
          this.accountsAlerts.demandUpdateSuccess();
        })
        .catch((error) => {
          this.accountsAlerts.demandUpdateError();
          this.$log.error('Failed to update account @shipperAccountPreferences@update', error);
        })
        .finally(() => {
          this.loading = false;
        })
    }
  }

  onAgentsSelect(agentIds) {
    this.account.autoAssignCourierIds = agentIds;
    this.update();
  }
}

angular
  .module('bringoz.admin.accounts')
  .component('shipperAccountDispatching', {
    bindings: {
      account: '<'
    },
    template: require('./shipper-account-dispatching.html').default,
    controller: ShipperAccountDispatchingCtrl
  });
